/**
 * Regex pattern to identify test categories (e.g., "final1", "midterm2")
 */
export const TEST_CATEGORY_PATTERN = /^(final|midterm)\d+$/;
